export { ChatService } from './lib/chat.service';

export * from './lib/shared-mt-bot.module';